import EditBook from "../edit/EditBook";

export default function EditPage() {
    return (
        <section className="pt-6 pb-20 min-h-[calc(100vh_-_157px)]">
            <EditBook/>
        </section>
    );
}
